export const lastStartYearNumber = 2025

export const lastStartYear = String(lastStartYearNumber)
export const lastYearRange = `${lastStartYearNumber}/${(lastStartYearNumber + 1) % 100}`

export const thisStartYear = String(lastStartYearNumber + 1)
export const thisYearRange = `${lastStartYearNumber + 1}/${(lastStartYearNumber + 2) % 100}`

export const nextStartYear = String(lastStartYearNumber + 2)
export const nextYearRange = `${lastStartYearNumber + 2}/${(lastStartYearNumber + 3) % 100}`